import React from "react";
import "./ProjectCard.css";
import bookIcon from "../../assests/images/projects/book.png";

export default function ProjectCard({ project, theme }) {
  return (
    <a
      href={project.link}
      target="_blank"
      rel="noopener noreferrer"
      className="project-card-link"
      style={{ color: theme.text }}
    >
      <div className="project-card" style={{ backgroundColor: theme.headerColor }}>
        <div className="projectlabel">
          <img src={bookIcon} alt="book" className="icon" />
          <span className="projecttitle">{project.title}</span>
        </div>

        <span className="projectdescription">{project.description}</span>

        <div className="dataAndTools">
          <span className="spanCreatedDate" style={{ color: theme.secondaryText }}>
            {project.date}
          </span>
          <div className="toolsIcons">
            {project.tools.map((tool) => (
              <img
                key={tool}
                src={require(`../../assests/images/${tool}`)}
                alt={tool.split("/").pop().split(".")[0]}
                className="iconTools"
              />
            ))}
          </div>
        </div>
      </div>
    </a>
  );
}
